import { createFeatureFlag } from "../functions/featureFlags";
import { getShopUrl } from "shared-frontend/functions/products";

// Black Friday 2025 campaign dates
// Start: November 27, 2025 at 11:00 AM CET (10:00 UTC) (the sale starts 10:30 CET, but we show banners 30 minutes later)
// End: December 2, 2025 at 11:00 AM CET (10:00 UTC)
export const BLACK_FRIDAY_START = new Date( "2025-11-27T10:00Z" );
export const BLACK_FRIDAY_END = new Date( "2025-12-02T10:00:00Z" );

/**
 * Determines if Black Friday banners should be displayed.
 *
 * Enable via:
 * - Environment variable: REACT_APP_ENABLE_BF_BANNER=true
 * - Query param: ?test_bf_banner (persists for browser session)
 * - Date range: automatically enabled during Black Friday period (when uncommented)
 *
 * @returns {boolean} True if Black Friday banners should be displayed.
 */
export const isBlackFridayActive = createFeatureFlag( "bf_banner", () => {
	// Uncomment during Black Friday period:
	// const now = new Date();
	// return now >= BLACK_FRIDAY_START && now <= BLACK_FRIDAY_END;
	return false;
} );

// Shop URL for Black Friday CTAs
export const BLACK_FRIDAY_SHOP_URL = getShopUrl() + "/shop/";
